import { PageWrapper, StatusTag, rem } from '@innovyze/stylovyze';

import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	max-width: 644px;
`;

export const CustomPageWrapper = styled(PageWrapper)`
	&& h3 {
		font-style: normal;
		font-weight: normal;
		font-size: 24px;
		margin: 0;
		padding: 0;
	}
`;

export const CustomStatusTag = styled(StatusTag)`
	height: ${rem(18)};
`;

export const CustomSecondaryMenu = styled.div`
	display: grid;
	grid-auto-flow: column;
	align-items: center;
	grid-gap: 8px;
`;
